import React from 'react';
import { reduxForm } from 'redux-form';
import FormField from '../form/form-field';
import DateField from '../form/date-field';
import SeasonSelect from '../season/season-select';
import TextField from '../form/text-field';
import BaseForm from '../form/base-form';
import { validateRequiredFields } from '../../utils/form';
import LocalizedStrings from '../../localization/strings';
import ExpandableContent from '../../components/expandable-content';

import Button from '../button';
import Alert from '../alert';

const fields = [
  'id',
  'name',
  'address',
  'stage_date',
  'seasonId',
  'regulations',
  'regulations_en',
  'registration_enabled',
  'has_results',
  'register_to_all_stages',
  'insurance_enabled',
  'live_results',
  'external_website_registration',
  'external_regulations_link',
  'external_registration_link',
  'external_participants_link',
  'global_results_stage',
  'register_to_custom_stages_list',
  'register_to_custom_stages',
  'show_in_main_window',
  'results_field_position_poz',

  'diploma_image',
  'generate_diploma',

  'paysera_project_id',
  'paysera_sign_password',
  'paysera_head_tag',

  'extra_info_field_title',
  'extra_info_field_required',
  'display_extra_info_field',

  'registration_closes_date'
];

function validate(values) {
  let errors = {
    _error: null
  };
  errors = validateRequiredFields(values, [
    'name', 'address', 'stage_date', 'seasonId'
  ], errors);
  if (values.external_website_registration) {
    errors = validateRequiredFields(values, [
      'external_regulations_link', 'external_registration_link', 'external_participants_link'
    ], errors);
  }
  return errors;
}

class StageForm extends BaseForm {

  render() {
    const {
      submitting,
      error,
      handleSubmit,
      fields: {
        name,
        address,
        stage_date,
        seasonId,
        regulations,
        registration_enabled,
        has_results,
        register_to_all_stages,
        insurance_enabled,
        live_results,
        regulations_en,
        external_website_registration,
        external_regulations_link,
        external_registration_link,
        external_participants_link,
        global_results_stage,
        register_to_custom_stages_list,
        register_to_custom_stages,
        show_in_main_window,
        results_field_position_poz,
        diploma_image,
        generate_diploma,
        paysera_project_id,
        paysera_sign_password,
        paysera_head_tag,

        extra_info_field_title,
        extra_info_field_required,
        display_extra_info_field,
        registration_closes_date
      }
    } = this.props;
    return (
      <div>
        <form onSubmit={handleSubmit(this.submit.bind(this))}>
          {error && <Alert type="error">{error}</Alert>}
          <ExpandableContent title={LocalizedStrings.stageInfo} expanded={true}>

            <FormField label={LocalizedStrings.season} name="season" field={seasonId}>
              <SeasonSelect field={seasonId}></SeasonSelect>
            </FormField>

            <FormField label={LocalizedStrings.title} name="name" field={name}>
              <input ref="name" className="border-full larger" placeholder={LocalizedStrings.title}
                     type="text" {...name} />
            </FormField>

            <FormField label={LocalizedStrings.date} name="address" field={stage_date}>
              <DateField {...stage_date}></DateField>
            </FormField>

            <FormField label={LocalizedStrings.registrationClosesDate} name="registration_closes_date" field={registration_closes_date}>
              <DateField {...registration_closes_date}></DateField>
            </FormField>

            <FormField label={LocalizedStrings.address} name="address" field={address}>
              <input ref="address" className="border-full larger" placeholder={LocalizedStrings.address}
                     type="text" {...address} />
            </FormField>
          </ExpandableContent>


          <ExpandableContent title={LocalizedStrings.regulations} expanded={true}>
            <FormField label={LocalizedStrings.ltLabel} name="regulations" field={regulations}>
              <TextField {...regulations}></TextField>
            </FormField>

            <FormField label={LocalizedStrings.enLabel} name="regulations" field={regulations_en}>
              <TextField {...regulations_en}></TextField>
            </FormField>
          </ExpandableContent>

          <ExpandableContent title={LocalizedStrings.stageInfo} expanded={true}>

            <fieldset>
              <FormField label={LocalizedStrings.registrationEnabled} name="registration_enabled"
                         field={registration_enabled} className="checkbox-field" dots={false}>
                <input type="checkbox" {...registration_enabled} />
              </FormField>
              <FormField label={LocalizedStrings.hasResults} name="has_results" field={has_results}
                         className="checkbox-field" dots={false}>
                <input type="checkbox" {...has_results} />
              </FormField>
              <FormField label={LocalizedStrings.liveResults} name="live_results" field={live_results}>
                <input ref="live_results" className="border-full larger" type="text"
                       placeholder={LocalizedStrings.liveResults}
                       {...live_results} />
              </FormField>

            </fieldset>

            <fieldset>
              <FormField label={LocalizedStrings.registerToAllStages} name="register_to_all_stages"
                         field={register_to_all_stages} className="checkbox-field" dots={false}>
                <input type="checkbox" {...register_to_all_stages} />
              </FormField>

              <FormField label={LocalizedStrings.globalResultsStage} name="global_results_stage"
                         field={global_results_stage} className="checkbox-field" dots={false}>
                <input type="checkbox" {...global_results_stage} />
              </FormField>
              <FormField label={LocalizedStrings.registerToCustomStages} name="register_to_custom_stages"
                         field={register_to_custom_stages} className="checkbox-field" dots={false}>
                <input type="checkbox" {...register_to_custom_stages} />
              </FormField>

              <FormField label={LocalizedStrings.registerToCustomStages} name="register_to_custom_stages_list"
                         field={register_to_custom_stages_list}>
                <input ref="register_to_custom_stages_list" className="border-full larger"
                       placeholder={LocalizedStrings.registerToCustomStages}
                       type="text" {...register_to_custom_stages_list} />
              </FormField>


            </fieldset>

            <fieldset>
              <legend>{LocalizedStrings.extraInfo}</legend>

              <FormField label={LocalizedStrings.displayExtraInfoField} name="display_extra_info_field"
                         field={display_extra_info_field} className="checkbox-field">
                <input type="checkbox" {...display_extra_info_field} />
              </FormField>

              <FormField label={LocalizedStrings.extraInfoFieldTitle} name="extra_info_field_title"
                         field={extra_info_field_title}>
                <input placeholder={LocalizedStrings.extraInfoFieldTitle} type="text" {...extra_info_field_title} />
              </FormField>

              <FormField label={LocalizedStrings.extraInfoFieldRequired} name="extra_info_field_required"
                         field={extra_info_field_required} className="checkbox-field">
                <input type="checkbox" {...extra_info_field_required} />
              </FormField>


            </fieldset>


            <FormField label={LocalizedStrings.showInMainWindow} name="show_in_main_window"
                       field={show_in_main_window} className="checkbox-field" dots={false}>
              <input type="checkbox" {...show_in_main_window} />
            </FormField>
            <FormField label={LocalizedStrings.insuranceEnabled} name="insurance_enabled"
                       field={insurance_enabled} className="checkbox-field" dots={false}>
              <input type="checkbox" {...insurance_enabled} />
            </FormField>

            <FormField label={LocalizedStrings.externalRegistration} name="external_website_registration"
                       field={external_website_registration} className="checkbox-field" dots={false}>
              <input type="checkbox" {...external_website_registration} />
            </FormField>

            {external_website_registration.value ? (
              <fieldset>
                <FormField label={LocalizedStrings.externalRegulationsLink} name="external_regulations_link"
                           field={external_regulations_link}>
                  <input ref="external_regulations_link" className="border-full larger"
                         placeholder={LocalizedStrings.externalRegulationsLink}
                         type="text" {...external_regulations_link} />
                </FormField>
                <FormField label={LocalizedStrings.externalRegistrationLink}
                           name="external_registration_link" field={external_registration_link}>
                  <input ref="external_registration_link" className="border-full larger"
                         placeholder={LocalizedStrings.externalRegistrationLink}
                         type="text" {...external_registration_link} />
                </FormField>
                <FormField label={LocalizedStrings.externalParticipantsLink}
                           name="external_participants_link" field={external_participants_link}>
                  <input ref="external_participants_link" className="border-full larger"
                         placeholder={LocalizedStrings.externalRegistrationLink}
                         type="text" {...external_participants_link} />
                </FormField>


              </fieldset>
            ) : null}

          </ExpandableContent>
          <ExpandableContent title={LocalizedStrings.resultsFileInfo} expanded={true}>

            <FormField label={LocalizedStrings.resultsPositionFieldValuePos}
                       name="results_field_position_poz" field={results_field_position_poz}>
              <input ref="results_field_position_poz" className="border-full larger"
                     placeholder={LocalizedStrings.resultsPositionFieldValuePos}
                     type="number" {...results_field_position_poz} />
            </FormField>

          </ExpandableContent>

          <ExpandableContent title={LocalizedStrings.diploma} expanded={true}>

            <FormField label={LocalizedStrings.generateDiploma} name="generate_diploma"
                       field={generate_diploma} className="checkbox-field" dots={false}>
              <input type="checkbox" {...generate_diploma} />
            </FormField>

            {generate_diploma.value ? (
              <FormField label={LocalizedStrings.diplomaBgImage} name="diploma_image"
                         field={diploma_image}>
                <textarea ref="diploma_image" className="border-full larger"  {...diploma_image} />
              </FormField>
            ) : null}

          </ExpandableContent>

          <ExpandableContent title={LocalizedStrings.paysera} expanded={false}>
            <FormField label={LocalizedStrings.projectId}
                       name="paysera_project_id" field={paysera_project_id}>

              <input ref="paysera_project_id" className="border-full larger"
                     placeholder={LocalizedStrings.projectId}
                     type="text" {...paysera_project_id} />
            </FormField>

            <FormField label={LocalizedStrings.projectPassword}
                       name="paysera_sign_password" field={paysera_sign_password}>

              <input ref="paysera_sign_password" className="border-full larger"
                     placeholder={LocalizedStrings.projectPassword}
                     type="text" {...paysera_sign_password} />
            </FormField>

            <FormField label={LocalizedStrings.projectHeadTag}
                       name="paysera_head_tag" field={paysera_head_tag}>

              <input ref="paysera_head_tag" className="border-full larger"
                     placeholder={LocalizedStrings.projectHeadTag}
                     type="text" {...paysera_head_tag} />
            </FormField>
          </ExpandableContent>


          <div className="actions-row">
            <Button loading={submitting} submit={true} disabled={submitting} type="primary">
              {LocalizedStrings.submit}
            </Button>

          </div>

        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'stage-form',
  fields,
  validate,
  destroyOnUnmount: true
}, state => ({
  initialValues: {
    registration_closes_date: null,
    registration_enabled: false,
    has_results: false,
    register_to_all_stages: false,
    register_to_custom_stages: false,
    global_results_stage: false,
    display_extra_info_field: false,
    show_in_main_window: false,
    insurance_enabled: false,
    external_website_registration: false,
    extra_info_field_required: false,
    generate_diploma: false,
    results_field_position_poz: 0,
    ...state.stage.stage.item
  }
}))(StageForm);



// WEBPACK FOOTER //
// ./src/js/components/stage/stage-form.js